import { dataHome } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHome = /*#__PURE__*/createIcon(dataHome)
export default IconHome
